import { CssVarsThemeOptions } from "@mui/material/styles";

import { createBaseOverrides } from "./base";
import { createButtonOverrides } from "./buttons";
import { createInputOverrides } from "./inputs";
import { createMenuOverrides } from "./menus";
import { createOverlayOverrides } from "./overlays";

type ThemeComponents = NonNullable<CssVarsThemeOptions["components"]>;

const createComponentOverrides = (): ThemeComponents => ({
  ...createBaseOverrides(),
  ...createButtonOverrides(),
  ...createInputOverrides(),
  ...createOverlayOverrides(),
  ...createMenuOverrides()
});

export default createComponentOverrides;
